export default function FormButton({ children, onClick }) {
    return (
        <button
            onClick={onClick}
            className="bg-[#4362a1] text-white font-bold py-2 px-4 rounded"
        >
            {children}
        </button>
    )
}